export default __webpack_public_path__ + "static/media/thum3.c049897c.jpg";